export default __webpack_public_path__ + "static/media/64.f53f2b88.png";